import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const myFoodTypesRoute: RouteConfig<'with-page'> = {
    name: 'My Food Types',
    path: '/work-opps/my-food-types',
    page: lazy(() => import('.')),
    context: 'member',
    flags: ['member-route'],
    permissions: ['workOps'],
}
